import React, { Component } from "react";
import Address from "./address";

import "../css/globalRules.less";

export class MapAndAddress extends Component {
  render() {
    return (
      <div class="container-fluid contact-sec px-0 mt-5">
        <div class="container">
          <h3>Showroom Address</h3>
        </div>
        <hr />
        <div class="container">
          <div class="row py-5 align-items-center">
            <div class="col-lg-7">
              <Address
                address={this.props.address}
                website={this.props.website}
                contact={this.props.contact}
                dealer={this.props.dealer}
                gmbLink={this.props.gmbLink}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MapAndAddress;
